module.exports = __webpack_public_path__ + "img/中国金融期货交易所@2x.8689c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/中国金融期货交易所@2x.png
// module id = JX0Q
// module chunks = 3